import Mock from 'mockjs';
const LoginUsers = [
  {
    id: 1,
    username: 'admin',
    password: '123456',
    name: 'admin'
  }
];

const Users = [];



export { LoginUsers, Users };
